import api from './store/api'

export const routes = [
  {
    path: '/user',
    name: 'user',
    component: {
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: 'logout',
        name: 'logout',
        component: {
          created () {
            this.$store.dispatch('logout')
              .then(() => {
                this.$router.push('/login')
              })
          }
        }
      },
      {
        path: 'token',
        component: {
          created () {
            api.Account
              .TemporaryToken()
              .then((response) => {
                console.log(encodeURIComponent(response.data.data))
              })
          }
        }
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login', name: 'login', component: require('./pages/Login')
  },
  {
    path: '/', name: 'index', component: require('./pages/Main')
  },
  {
    path: '/LoginByToken/:username/:token/:lessonId',
    component: {
      mounted () {
        this.$store.dispatch('LoginByToken', { username: this.$route.params.username, loginToken: decodeURIComponent(this.$route.params.token) })
          .then((response) => {
            if (response.data.access_token !== '') {
              this.$store.commit('login', response.data)
              this.$router.push('/Lesson/' + this.$route.params.lessonId)
            } else {
              this.$router.push('/login')
            }
          })
      }
    },
    meta: {
      requiresAuth: false
    }
  },

  {
    path: '/LoginByToken/:username/:token/ref/:ref',
    component: {
      mounted () {
        this.$store.dispatch('LoginByToken', { username: this.$route.params.username, loginToken: decodeURIComponent(this.$route.params.token) })
          .then((response) => {
            if (response.data.access_token !== '') {
              this.$store.commit('login', response.data)
              this.$router.push(decodeURIComponent(this.$route.params.ref))
            } else {
              this.$router.push('/login')
            }
          })
      }
    },
    meta: {
      requiresAuth: false
    }
  },

  {
    path: '/group-mgr',
    name: 'group-mgr',
    component: {
      template: '<router-view></router-view>'
    },
    children: [
      { path: '', name: 'group-mgr.index', component: require('./pages/Teacher/TeachingGroup') },
      { path: 'add/group', name: 'group-mgr.add', component: require('./pages/Teacher/TeachingGroupEditor') },
      { path: 'edit/:groupId', name: 'group-mgr.edit', component: require('./pages/Teacher/TeachingGroupEditor') },
      { path: 'group/:groupId/student/add', name: 'group-mgr.student.add', component: require('./pages/Teacher/TeachingGroupAddStudent') },
      { path: 'group/:groupId/student/excel', name: 'group-mgr.student.excel', component: require('./pages/Teacher/TeachingGroupAddStudentByExcel') }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/home',
    name: 'home',
    component: require('./pages/cloud/CloudHome.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/AR',
    name: 'index',
    component: require('./pages/cloud/ar/ARLayout'),
    children: [
      { path: '', name: 'ARIndex', component: require('./pages/cloud/ar/ARIndex.vue') },
      { path: 'record', name: 'Record.classList', component: require('./pages/cloud/ar/record/ClassList.vue') },
      { path: 'record/summary/:mode/:class/:country?/:lesson?', name: 'Record.summary', component: require('./pages/cloud/ar/record/RecordSummary.vue') },
      { path: 'record/student/:mode', name: 'Record.country', component: require('./pages/cloud/ar/record/RecordCountry.vue') },
      { path: 'record/student/:mode/:country', name: 'Record.lesson', component: require('./pages/cloud/ar/record/RecordLesson.vue') },
      { path: 'record/:mode/:country/:id/:lesson?', name: 'Record.member', component: require('./pages/cloud/ar/record/Record.vue') }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/AR/option',
    name: 'option',
    component: require('./pages/cloud/ar/Options.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/AR/Lesson/:id',
    name: 'ar',
    component: require('./pages/cloud/ar/ARLayout.vue'),
    children: [
      {path: 'page=:page', name: 'ar_lesson', component: require('./pages/cloud/ar/Lesson.vue')},
      {path: 'download', name: 'ar_download', component: require('./pages/cloud/ar/Download.vue')},
      {path: ':category', name: 'ar_resource', component: require('./pages/cloud/ar/Resource.vue')}
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/AR/play/:lessonId',
    name: 'c_play',
    component: require('./pages/LessonPlayer'),
    meta: {
      requiresAuth: true
    }
  },
  // TW
  {
    path: '/TravelTaiwan',
    name: 'travel-taiwan',
    component: require('./pages/cloud/tw/TWLayout.vue'),
    children: [
      { path: '', name: 'TWIndex', component: require('./pages/cloud/tw/TwIndex.vue') },
      { path: 'record', name: 'Record.classList.tw', component: require('./pages/cloud/tw/record/ClassList.vue') },
      { path: 'record/learn/:class', name: 'Record.summary.tw', component: require('./pages/cloud/tw/record/RecordSummary.vue') },
      { path: 'record/learn/:class/:student', name: 'Record.personal.tw', component: require('./pages/cloud/tw/record/RecordPersonal.vue') },
      { path: 'record/learn/:class/:student/:point', name: 'Record.personal.point.tw', component: require('./pages/cloud/tw/record/RecordPersonal.vue') },
      { path: 'record/learn/:class/:student/:point/info', name: 'Record.info.tw', component: require('./pages/cloud/tw/record/RecordPersonalInfo.vue') },
      { path: 'record/mission/:class', name: 'Record.summary.mission', component: require('./pages/cloud/tw/record/RecordMission.vue') },
      { path: 'record/mission/:class/:student/', name: 'Record.mission.info', component: require('./pages/cloud/tw/record/RecordMissionInfo.vue') },
      { path: 'record/mission/:class/:student/:topic?', name: 'Record.mission.info', component: require('./pages/cloud/tw/record/RecordMissionInfo.vue') }
    ],
    meta: {
      requiresAuth: true
    }
  },
  // VR
  {
    path: '/VR',
    name: 'VR',
    component: require('./pages/cloud/vr/VRLayout.vue'),
    children: [
      { path: '', name: 'VRIndex', component: require('./pages/cloud/vr/VRIndex.vue') },
      { path: 'vocabulary', name: 'vocabulary', component: require('./pages/cloud/vr/VocabularyMission.vue') },
      // { path: 'conversation', name: 'conversation', component: require('./pages/cloud/vr/ConversationMission.vue') },
      { path: 'conversation/:id', name: 'conversation', component: require('./pages/cloud/vr/ConversationMission.vue') },
      { path: 'conversation/edit/:id', name: 'conversation_edit', component: require('./pages/cloud/vr/ConversationEdit.vue') },
      { path: 'record/classroom/', name: 'Classroom_record', component: require('./pages/cloud/vr/ClassroomList.vue') },
      { path: 'record/classroom/:id', name: 'VR_record', component: require('./pages/cloud/vr/Record.vue') },
      { path: 'classroom', name: 'VR_classroom', component: require('./pages/cloud/vr/ClassroomList.vue') },
      { path: 'classroom/:id', name: 'VR_student', component: require('./pages/cloud/vr/StudentList.vue') },
      { path: 'resource', name: 'VR_resource', component: require('./pages/cloud/vr/Resource.vue') }
    ],
    meta: {
      requiresAuth: true
    }
  },
  { path: '*', redirect: { name: 'home' } }
]



// WEBPACK FOOTER //
// ./src/routes.js